<template>
    <div style="background: #f0f2f2">
        <div class="nav">
            <v-head></v-head>
        </div>
        <!-- <v-route :bindData="bindData"></v-route> -->
        <div class="container" style="background: white;    box-shadow: 3px 3px 6px 0px rgba(0, 0, 0, 0.14);
    border-radius: 4px;padding: 0 10px">
            <v-breadcrumb value1="首页" :value2="value4" :value3="value2" :value4="value3" :url="url"></v-breadcrumb>
            <div class="container_box mt20 mb20">
                <h2 :class="{'center':data.id =='8a9a9d8073d621d20173e6d28f721424'||data.id=='8a9a9d8073d621d20173e6ca852013cd'}">{{data.title}}</h2>
                <video v-if="data.href" class="content" :src="data.href" style="width: 100%;padding-bottom: 20px" controls="controls" object-fit="cover">
                    您的浏览器不支持 video 标签。
                </video>
                <div class="content" style="padding-bottom: 20px" v-html="data.content" ></div>
            </div>
        </div>
        <v-footer></v-footer>
    </div>
</template>

<script>
    import route from '../../components/common/route1'
    export default {
        name: "list1",
        data(){
            return{
                data:{
                    title:null
                },
                value2:null,
                value3:null,
                value4:null,
                url:null,
                bindData:null
            }
        },
        created() {
           this.initBindData();
           this.getDetail();
        },
        watch:{
            $route:function (newValue) {
                console.log(newValue);
                let that = this;
                let ljcode = newValue.query.ljcode;
                let articleId = newValue.query.articleId;
                let rootColumnId = newValue.query.rootColumnId;
                let columnId = newValue.query.columnId;
                this.url = [ljcode,rootColumnId,columnId]
                let url = `${api}/api/cms/article/detail?articleId=${articleId}`;
                this.common.axios.get(url).then(v=>{    
          
                    that.data = v.data.data;
                     that.value2 = that.data.columnInfo.name
                     that.value4=that.data.columnInfo.name
                    that.value3 = that.data.title;
                });
                this.initBindData();
            }
        },
        methods:{
            initBindData(){
                switch (this.$route.query.rootColumnId) {
                    case '40288a9d6e91c70a016e91c787ba0000':
                        this.bindData = [
                            {
                                name:'廉江概览',
                                url:'#/list1?ljcode=ljgl&columnId=40288a9d6e91c70a016e91cabebd0006&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                                cid:'40288a9d6e91c70a016e91cabebd0006'
                            },
                            {
                                name:'廉江动态',
                                url:'#/list2?ljcode=ljdt&columnId=40288a9d6e91c70a016e91caf27c0007&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                                cid:'40288a9d6e91c70a016e91caf27c0007'
                            },
                            {
                                name:'节庆活动',
                                url:'#/jqhd?ljcode=jqhd&columnId=40288a9d6e91c70a016e91cb31640008&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                                cid:'40288a9d6e91c70a016e91cb31640008'
                            },
                            {
                                name:'音画廉江',
                                url:'#/yhlj?ljcode=yhlj&columnId=40288a9d6e91c70a016e91cb9d910009&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                                cid:'40288a9d6e91c70a016e91cb9d910009'
                            }
                        ]
                }
            },
            getDetail(){
                let that = this;
                let ljcode = this.$route.query.ljcode;
                let articleId = this.$route.query.articleId;
                let rootColumnId = this.$route.query.rootColumnId;
                let columnId = this.$route.query.columnId;
                this.url = [ljcode,rootColumnId,columnId]

                let url = `${api}/api/cms/article/detail?articleId=${articleId}`;
                this.common.axios.get(url).then(v=>{
                    console.log(v.data.data,12312);
                    that.data = v.data.data;
                    that.value2 = that.data.columnInfo.name
                    that.value4=that.data.rootColumnInfo.name
                    that.data.content = that.data.content.replace(/\s+/g," ");
                    
                    that.value3 = that.data.title;
                });
            },
        },
        components:{
            "v-route":route
        }


    }
</script>

<style lang="less" scoped>
    .nav{
        height: 350px;
        background: url("../../assets/img/headerbanner.jpg");
    }
    .center{
        text-align: center !important;
    }
    .container_box{
        h2{
            font-size: 36px;
            line-height: 70px;
            height: 70px;
            color: black;
            letter-spacing: 5px;
            text-align: left;
        }

        text-align: justify;
    }
</style>
<style lang="less">
    .content{
    p{
        text-indent: 0em !important;
        line-height: 32px !important;
        font-size: 14px !important;
        color: #666666 !important;
      
    span{
        font-size: 14px !important;
        color: #666666 !important;
    }
    }
    img{
        max-width: 100% !important;
    }
    table,table tr th, table tr td { border:1px solid black;vertical-align:middle }
    }
</style>
